import React from "react";

interface SlaContentProps {
  clientName: string;
  representativeName: string;
  representativeRole: string;
  date: string;
}

const SlaContent: React.FC<SlaContentProps> = ({
  clientName,
  date,
  representativeName,
  representativeRole,
}) => {
  return (
    <div className="font-abel text-gray-700 text-sm leading-relaxed space-y-6 p-5 bg-white shadow-sm rounded-lg border border-gray-100 max-w-[1024px] mx-auto">
      <div className="text-center mb-10 border-b pb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">25th Suite</h1>
        <h2 className="text-2xl font-semibold text-gray-800 mb-6">
          Service Level Agreement
        </h2>
        <p className="text-lg">for</p>
        <p className="text-xl font-bold text-primary my-2">{clientName}</p>
        <br />
        {/* <p className="text-md text-gray-500">Prepared by 25th & Staffing</p> */}
        <p className="text-md text-gray-500 mt-2">Date: {date}</p>
      </div>

      <div className="bg-gray-50 p-6 rounded-md mb-8">
        <h3 className="font-bold text-lg mb-4">Table of Contents</h3>
        <ul className="list-decimal pl-5 space-y-1">
          <li>Purpose of This SLA</li>
          <li>Solution Overview & Service Description</li>
          <li>Uptime & Availability Commitments</li>
          <li>Performance Metrics</li>
          <li>Support & Incident Response</li>
          <li>Security & Compliance</li>
          <li>Disaster Recovery & Business Continuity</li>
          <li>{clientName} Responsibility</li>
          <li>25th Direct Responsibilities</li>
          <li>ANNEX B – Data Processing Addendum (DPA)</li>
          <li>Support Handbook (Annex C)</li>
          <li>Implementation Timeline & Express Mode</li>
          <li>General Provisions</li>
        </ul>
      </div>

      <section>
        <h3 className="font-bold text-lg mb-2">1. Purpose of This SLA</h3>
        <p>
          <strong>1.1</strong> This SLA defines the service scope, performance
          commitments, security standards, governance controls, and operational
          responsibilities governing the deployment of the 25th Suite:
        </p>
        <ul className="list-disc pl-5 mt-2">
          <li>25th AI Recruiter</li>
          <li>25th Direct</li>
          <li>25th Console</li>
        </ul>
        <p className="mt-2">for {clientName}.</p>
        <p className="mt-2">
          <strong>1.2. Scope:</strong> This SLA covers the isolation of the
          pilot to the designated company(ies), prevention of unauthorized
          access/expansion, and our response commitments. It applies during the
          pilot phase (3–6 months) and any extension.
        </p>
      </section>

      <section>
        <h3 className="font-bold text-lg mb-2">
          2. Solution Overview & Service Description
        </h3>

        <div className="mb-4">
          <h4 className="font-semibold mb-1">
            2.1 AI Recruiter – Enterprise Plus (Recommended)
          </h4>
          <p>
            A high-volume AI interviewing with standard enterprise support. It
            provides AI-led transcription (audio/video), scoring, configurable
            templates, dashboards and secure hosting. The intelligent hiring
            engine is designed to support high-volume, regulated, and
            operationally critical recruitment across {clientName}’s technical,
            commercial, and corporate workforce.
          </p>
          {/* <div className="overflow-x-auto mt-2">
            <table className="min-w-full text-left text-xs border">
              <thead className="bg-gray-100 font-bold">
                <tr>
                  <th className="p-2 border">Module</th>
                  <th className="p-2 border">Description</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="p-2 border font-semibold">
                    AI Interview Engine
                  </td>
                  <td className="p-2 border">
                    Automated, structured AI-led interviews with standardized
                    scoring, transcripts, and audit-ready evaluations.
                  </td>
                </tr>
                <tr>
                  <td className="p-2 border font-semibold">
                    Advanced Interview Evaluation & Reporting
                  </td>
                  <td className="p-2 border">
                    Advanced AI Algorithm of efficient and reliable Interview
                    evaluation, overall scoring and reporting.
                  </td>
                </tr>
                <tr>
                  <td className="p-2 border font-semibold">
                    Utility Workforce Hiring
                  </td>
                  <td className="p-2 border">
                    High-volume hiring workflows for technicians, meter
                    installers, customer service, and outage-response teams.
                  </td>
                </tr>
                <tr>
                  <td className="p-2 border font-semibold">
                    Technical & Field Role Assessments
                  </td>
                  <td className="p-2 border">
                    Pre-configured assessments for engineers, technicians, call
                    center agents, and operational staff.
                  </td>
                </tr>
                <tr>
                  <td className="p-2 border font-semibold">
                    Compliance & Bias Control
                  </td>
                  <td className="p-2 border">
                    Structured interview logic designed to support fairness,
                    consistency, and regulatory expectations.
                  </td>
                </tr>
                <tr>
                  <td className="p-2 border font-semibold">
                    Secure Enterprise Deployment
                  </td>
                  <td className="p-2 border">
                    Encrypted data handling and controlled access aligned with
                    enterprise and utility standards.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <p className="mt-2 italic">
            <strong>Outcome for {clientName}:</strong> Faster, fairer, and
            auditable hiring at scale without compromising regulatory or
            operational standards.
          </p> */}
        </div>

        {/* <div className="mb-4">
          <h4 className="font-semibold mb-1">
            2.2 25th Direct – Enterprise Automation Layer (Recommended)
          </h4>
          <p>
            Advanced end-to-end recruitment automation layer, covering sourcing,
            parsing, scoring, mass hiring and enterprise integrations. Built for
            utilities managing thousands of employees across multiple
            operational zones.
          </p>
          <p className="mt-1">
            <strong>Integration Scope Limitation:</strong> The agreement covers
            standard RESTful API integrations with supported platforms (e.g.,
            LinkedIn, Indeed, standard HRIS).
          </p>
          <p className="mt-1">
            <strong>Legacy Systems:</strong> Integration with on-premise ERPs
            (e.g., SAP, Oracle E-Business Suite) or systems requiring custom
            middleware, SOAP protocol adaptation, or extensive firewall
            configuration is considered out-of-scope.
          </p>
          <p className="mt-1">
            <strong>Custom Scoping:</strong> Such integrations will be scoped
            separately and billed at a daily engineering rate (or agreed project
            fee) following a technical discovery session.
          </p>
          <div className="overflow-x-auto mt-2">
            <table className="min-w-full text-left text-xs border">
              <thead className="bg-gray-100 font-bold">
                <tr>
                  <th className="p-2 border">Module</th>
                  <th className="p-2 border">Description</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="p-2 border font-semibold">
                    AI Interview & Decision Support
                  </td>
                  <td className="p-2 border">
                    Advanced AI interviews combined with human-in-the-loop final
                    approvals.
                  </td>
                </tr>
                <tr>
                  <td className="p-2 border font-semibold">
                    CV Parsing & Scoring Engine
                  </td>
                  <td className="p-2 border">
                    Bulk CV upload, intelligent parsing, and AI ranking based on
                    role-specific competency frameworks.
                  </td>
                </tr>
                <tr>
                  <td className="p-2 border font-semibold">
                    RAG Search Engine
                  </td>
                  <td className="p-2 border">
                    Semantic, vector-based search across historical CVs, talent
                    pools, and internal hiring data.
                  </td>
                </tr>
                <tr>
                  <td className="p-2 border font-semibold">
                    Job Board & Talent Source Integrations
                  </td>
                  <td className="p-2 border">
                    Integration with Jobberman, Indeed, LinkedIn RSC APIs, and
                    internal referral pipelines.
                  </td>
                </tr>
                <tr>
                  <td className="p-2 border font-semibold">
                    Utility Workforce Module
                  </td>
                  <td className="p-2 border">
                    Large-scale recruitment workflows for field operations,
                    customer service, and emergency response hiring.
                  </td>
                </tr>
                <tr>
                  <td className="p-2 border font-semibold">Hiring Analytics</td>
                  <td className="p-2 border">
                    Real-time insights into time-to-hire, funnel performance,
                    and quality-of-hire across departments.
                  </td>
                </tr>
                <tr>
                  <td className="p-2 border font-semibold">
                    HRIS / ERP Integration
                  </td>
                  <td className="p-2 border">
                    Integration with SAP, Oracle, Workday Greenhouse, or
                    existing internal HR systems.
                  </td>
                </tr>
                <tr>
                  <td className="p-2 border font-semibold">
                    Offer Letter & e-Signature Automation
                  </td>
                  <td className="p-2 border">
                    Automated offer issuance, approvals, and digital signing.
                  </td>
                </tr>
                <tr>
                  <td className="p-2 border font-semibold">
                    On-Premise / Private Cloud Option
                  </td>
                  <td className="p-2 border">
                    Deployment suitable for regulated and
                    infrastructure-sensitive environments.
                  </td>
                </tr>
                <tr>
                  <td className="p-2 border font-semibold">
                    Bespoke Customization from existing standard
                  </td>
                  <td className="p-2 border">
                    Customize features to your own specific needs, highly
                    bespoke.
                  </td>
                </tr>
                <tr>
                  <td className="p-2 border font-semibold">
                    White-Label & Enterprise Branding
                  </td>
                  <td className="p-2 border">
                    Custom domain, branding, and enterprise-grade configuration.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <p className="mt-2 italic">
            <strong>Outcome for {clientName}:</strong> A single, automated
            hiring backbone that reduces dependency on external agencies, lowers
            cost-per-hire, and standardizes recruitment across all zones.
          </p>
        </div> */}

        {/* <div className="mb-4">
          <h4 className="font-semibold mb-1">
            2.3 25th Console – Enterprise & Control Layer (Recommended)
          </h4>
          <p>
            Productivity console for task tracking, meeting management, and
            document control with advanced permission levels.
          </p>
          <div className="overflow-x-auto mt-2">
            <table className="min-w-full text-left text-xs border">
              <thead className="bg-gray-100 font-bold">
                <tr>
                  <th className="p-2 border">Module</th>
                  <th className="p-2 border">Description</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="p-2 border font-semibold">Task Manager</td>
                  <td className="p-2 border">
                    Track users' activity with respect to issues and tasks
                    raised, which will be eventually tracked by the KPI
                    dashboard.
                  </td>
                </tr>
                <tr>
                  <td className="p-2 border font-semibold">
                    Meeting Scheduling & Management
                  </td>
                  <td className="p-2 border">
                    Schedule and manage internal and external meetings via the
                    same platform with advanced meeting management and invite
                    features.
                  </td>
                </tr>
                <tr>
                  <td className="p-2 border font-semibold">Ticketing System</td>
                  <td className="p-2 border">
                    Create tickets to manage tasks and issues that can be
                    tracked via the KPI analytics dashboard for the CEO.
                  </td>
                </tr>
                <tr>
                  <td className="p-2 border font-semibold">
                    Advanced File Management System
                  </td>
                  <td className="p-2 border">
                    Manage files with permission levels and sharing with access
                    controls.
                  </td>
                </tr>
                <tr>
                  <td className="p-2 border font-semibold">
                    In-built Chat System
                  </td>
                  <td className="p-2 border">
                    Chat and share files with in-house company users on the same
                    platform.
                  </td>
                </tr>
                <tr>
                  <td className="p-2 border font-semibold">
                    Services & License expiration Tracking
                  </td>
                  <td className="p-2 border">
                    Identify high-performing regions and replicate best-practice
                    staffing models enterprise-wide.
                  </td>
                </tr>
                <tr>
                  <td className="p-2 border font-semibold">
                    HR CV Matching System
                  </td>
                  <td className="p-2 border">
                    Centralized logs, approvals, and reports to support
                    regulatory audits and internal governance.
                  </td>
                </tr>
                <tr>
                  <td className="p-2 border font-semibold">
                    Application Activity Log tracking
                  </td>
                  <td className="p-2 border">
                    Manage authentication activities within the platform to know
                    which user is active and when.
                  </td>
                </tr>
                <tr>
                  <td className="p-2 border font-semibold">
                    Advanced User Management and Permission Level
                  </td>
                  <td className="p-2 border">
                    Manage users with an advanced permissions level structure
                    for application access
                  </td>
                </tr>
                <tr>
                  <td className="p-2 border font-semibold">
                    Task & Ticketing System KPI tracking and reporting
                  </td>
                  <td className="p-2 border">
                    Track and Report all users KPI for the CEO in one dashboard
                  </td>
                </tr>
                <tr>
                  <td className="p-2 border font-semibold">
                    Bespoke Custom Integrations
                  </td>
                  <td className="p-2 border">
                    Request for tailor-made solutions as it fits into your
                    working environment.
                  </td>
                </tr>
                <tr>
                  <td className="p-2 border font-semibold">
                    Secure, Encrypted Data Layer
                  </td>
                  <td className="p-2 border">
                    Fully encrypted, isolated data handling aligned with
                    enterprise security requirements.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div> */}
        {/* <div className="mb-4">
          <h4 className="font-semibold mb-1">
            2.4 Pilot Phase & Full Employer Lifecycle
          </h4>
          <p>
            To ensure measurable impact without disrupting critical power
            distribution operations, we recommend a phased “Pilot-to-Scale”
            deployment strategy tailored to {clientName}’s operational
            complexity.
          </p>
          <p className="mt-2 text-sm font-semibold">
            Phase 1: Controlled Pilot (ROI Validation)
          </p>
          <p>
            We propose a 30-day pilot within one or two high-impact business
            units or operational zones (e.g., technical field operations or
            customer service hiring).
          </p>
          <ul className="list-disc pl-5 mt-1 text-xs">
            <li>High-volume CV inflow and screening efficiency</li>
            <li>Reduction in recruiter administrative workload</li>
            <li>
              Improved role-fit quality for operational and technical roles
            </li>
          </ul>
          <p className="mt-2 text-sm font-semibold">
            Phase 2: Enterprise Rollout (Scale with Confidence)
          </p>
          <p>
            Once outcomes are validated, the platform will be seamlessly scaled
            across {clientName}’s regions and departments, ensuring standardized
            hiring practices, centralized visibility, and long-term cost
            efficiency.
          </p>
        </div>

        <div className="bg-gray-50 p-4 rounded mb-4 text-xs">
          <h4 className="font-semibold mb-2">
            The {clientName} Growth Suite: Strategic Options
          </h4>
          <p>
            <strong>Option A: Enterprise Control Bundle (Recommended)</strong>:
            Includes all 3 modules across all regions. Best for fully integrated
            hiring control.
          </p>
          <p className="mt-2">
            <strong>Option B: Phased Modular Entry</strong>: Includes AI
            Recruiter + Direct + Console. Ideal for addressing immediate
            high-volume hiring pressure first.
          </p>
          <p className="mt-4 font-semibold text-center italic">
            "The Bottom Line: Lower recruitment overhead, Faster deployment of
            critical talent, Centralized governance."
          </p>
        </div> */}
      </section>

      {/* <section>
        <h3 className="font-bold text-lg mb-2">
          3. Uptime & Availability Commitments
        </h3>
        <div className="overflow-x-auto mt-2">
          <table className="min-w-full text-left text-xs border">
            <thead className="bg-gray-100 font-bold">
              <tr>
                <th className="p-2 border">Solution</th>
                <th className="p-2 border">Plan</th>
                <th className="p-2 border">Monthly Uptime</th>
                <th className="p-2 border">Notes</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="p-2 border">AI Recruiter</td>
                <td className="p-2 border">Enterprise Plus</td>
                <td className="p-2 border">99.5%</td>
                <td className="p-2 border">Standard enterprise plan.</td>
              </tr>
              <tr>
                <td className="p-2 border">AI Recruiter</td>
                <td className="p-2 border">Enterprise VIP</td>
                <td className="p-2 border">99.5%</td>
                <td className="p-2 border">Premium plan.</td>
              </tr>
              <tr>
                <td className="p-2 border">25th Direct</td>
                <td className="p-2 border">Direct Enterprise</td>
                <td className="p-2 border">99.5%</td>
                <td className="p-2 border">Mission-critical automation.</td>
              </tr>
              <tr>
                <td className="p-2 border">25th Direct</td>
                <td className="p-2 border">Direct VIP</td>
                <td className="p-2 border">99.5%</td>
                <td className="p-2 border">High-availability option.</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="mt-2">
          <strong>3.2 Service Levels:</strong> Isolation Uptime: 99.5%.
          Detection Response Time: 4-24 hours. Audit Frequency: Quarterly.
        </p>
        <p className="mt-2">
          <strong>3.6 Service Availability:</strong> 99.5% of the time for
          Enterprise plans.
        </p>
      </section>

      <section>
        <h3 className="font-bold text-lg mb-2">4. Performance Metrics</h3>
        <div className="overflow-x-auto mt-2">
          <table className="min-w-full text-left text-xs border">
            <thead className="bg-gray-100 font-bold">
              <tr>
                <th className="p-2 border">Metric</th>
                <th className="p-2 border">Target</th>
                <th className="p-2 border">Description</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="p-2 border">AI Response Time</td>
                <td className="p-2 border">&lt; 7s</td>
                <td className="p-2 border">Average time for AI reply.</td>
              </tr>
              <tr>
                <td className="p-2 border">RAG Search Latency</td>
                <td className="p-2 border">&lt; 350ms</td>
                <td className="p-2 border">Vector search speed.</td>
              </tr>
              <tr>
                <td className="p-2 border">Video Start Time</td>
                <td className="p-2 border">&lt; 5s</td>
                <td className="p-2 border">Real-time interview boot.</td>
              </tr>
              <tr>
                <td className="p-2 border">Transcription Accuracy</td>
                <td className="p-2 border">≥ 85%</td>
                <td className="p-2 border">Speech-to-text accuracy.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section>
        <h3 className="font-bold text-lg mb-2">
          5. Support & Incident Response
        </h3>
        <p>
          <strong>5.1 Response Targets:</strong> S1-Critical (1 hr), S2-High (4
          hrs), S3-Medium (1 day), S4-Low (2 days).
        </p>
        <p className="mt-2">
          <strong>5.2 Authorized Support Contacts:</strong> Support tickets
          accepted only from Designated Administrators (IT/HR).
        </p>
        <p className="mt-2">
          <strong>5.3 Storage Fair Use Policy:</strong> Enterprise Plan includes
          100 GB. Overage billed at prevailing rate.
        </p>
      </section> */}

      {/* <section>
        <h3 className="font-bold text-lg mb-2">6. Security & Compliance</h3>
        <p>
          AES-256 encryption at rest, TLS 1.2+ in transit, NDPA 2023 compliance.
        </p>
        <p className="mt-1">
          <strong>6.1 Data Privacy & Integrity:</strong> Strict prohibition on
          data sale or misuse.
        </p>
        <p className="mt-1">
          <strong>6.2 IP & Account Sharing:</strong> No sharing credentials with
          third parties without consent.
        </p>
        <p className="mt-1">
          <strong>6.3 Audit Rights:</strong> Quarterly audit of usage logs.
        </p>
      </section>

      <section>
        <h3 className="font-bold text-lg mb-2">
          7. Disaster Recovery & Business Continuity
        </h3>
        <p>
          RTO ≤ 60 mins. RPO ≤ 24 hrs. Daily encrypted backups (for
          client-managed DBs).
        </p>
      </section>

      <section>
        <h3 className="font-bold text-lg mb-2">8. Client Responsibility</h3>
        <p>
          {clientName} serves as primary client, providing L1 support,
          coordinating access, and nominating business owners.
        </p>
      </section>

      <section>
        <h3 className="font-bold text-lg mb-2">
          9. 25th Direct Responsibilities
        </h3>
        <p>
          Ensure platform availability, L3 support, system maintenance, security
          patches, DR processes, and integration support.
        </p>
      </section>

      <section>
        <h3 className="font-bold text-lg mb-2">
          10. ANNEX B – Data Processing Addendum (DPA)
        </h3>
        <p>
          <strong>Roles:</strong> Controller ({clientName}), Processor (25th
          Direct).
        </p>
        <p>
          <strong>Scope:</strong> Processor acts only on written instructions.
          Applies AES-256/TLS 1.2+. Deletes data post-termination (~60 days).
        </p>
      </section>

      <section>
        <h3 className="font-bold text-lg mb-2">
          11. Support Handbook (Annex C)
        </h3>
        <p>
          <strong>Support Tiers:</strong> Direct Start (Std), Direct Pro
          (Priority), Enterprise (Priority + QBR), VIP (24x7).
        </p>
      </section>

      <section>
        <h3 className="font-bold text-lg mb-2">
          12. Implementation Timeline & Express Mode
        </h3>
        <p>
          Typical timeline: ~4 weeks for full deployment. Express Mode available
          (up to 30% faster).
        </p>
      </section>

      <section>
        <h3 className="font-bold text-lg mb-2">13. General Provisions</h3>
        <p>
          <strong>13.1 Force Majeure:</strong> Not liable for acts of God, war,
          etc. Notification within 48 hours.
        </p>
        <p>
          <strong>13.2 Third-Party Integrations:</strong> Not responsible for
          third-party interruptions or breaches.
        </p>
      </section>

      <div className="mt-10 border-t pt-8">
        <h3 className="font-bold text-xl mb-6">14. Signatures</h3>
        <p>
          IN WITNESS WHEREOF, the parties have caused this SLA to be executed by
          their duly authorized representatives as of the Effective Date.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mt-8">
          <div className="border p-6 rounded-lg bg-gray-50">
            <p className="font-bold mb-4">
              For: 25th & Staffing Limited (25th Suite)
            </p>
            <div className="space-y-3">
              <p className="border-b border-gray-400 pb-1">
                <strong>Name:</strong> Atsu Emmanuel
              </p>
              <p className="border-b border-gray-400 pb-1">
                <strong>Title:</strong> CTO
              </p>
              <p className="border-b border-gray-400 pb-1">
                <strong>Date:</strong> {date}
              </p>
            </div>
          </div>

          <div className="border p-6 rounded-lg bg-gray-50">
            <p className="font-bold mb-4">For: {clientName}</p>
            <div className="space-y-3">
              <p className="border-b border-gray-400 pb-1">
                <strong>Name: </strong>
                {representativeName}
              </p>
              <p className="border-b border-gray-400 pb-1">
                <strong>Title: </strong>
                {representativeRole}
              </p>
              <p className="border-b border-gray-400 pb-1">
                <strong>Date:</strong> {date}
              </p>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default SlaContent;
